<template>
  <div>
    <div v-if="aberta" class="modal-backdrop fade show"></div>

    <div class="gaveta-filtros border-bottom shadow-sm" :class="{ 'gaveta-aberta': aberta }">
      <div class="container-fluid py-2">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <h6 class="mb-0 gaveta-titulo"><i class="bi bi-sliders me-1"></i> Filtros Avançados</h6>
          <button class="btn btn-sm btn-outline-secondary" @click="$emit('fechar')">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <div class="row g-2 align-items-end">
          <div class="col-md-3">
            <label class="form-label small mb-0 gaveta-label">Nº Doc. Entrada</label>
            <input v-model="filtrosLocais.numeroDocumentoEntrada" type="text" class="form-control form-control-sm" placeholder="Buscar...">
          </div>
          <div class="col-md-3">
            <label class="form-label small mb-0 gaveta-label">Doc. Transporte</label>
            <input v-model="filtrosLocais.numeroDocumentoTransporte" type="text" class="form-control form-control-sm" placeholder="Buscar...">
          </div>
          <div class="col-md-3">
            <label class="form-label small mb-0 gaveta-label">Período ETA</label>
            <div class="d-flex gap-1">
              <input v-model="filtrosLocais.dataEtaInicio" type="date" class="form-control form-control-sm">
              <input v-model="filtrosLocais.dataEtaFim" type="date" class="form-control form-control-sm">
            </div>
          </div>
          <div class="col-md-3 d-flex gap-2 align-items-end pb-1">
            <div class="form-check">
              <input v-model="filtrosLocais.ocultarSaldoZero" type="checkbox" class="form-check-input" id="chkSaldoZero">
              <label class="form-check-label small" for="chkSaldoZero">Ocultar saldo zero</label>
            </div>
            <div class="form-check">
              <input v-model="filtrosLocais.apenasDisponivel" type="checkbox" class="form-check-input" id="chkDisponivel">
              <label class="form-check-label small" for="chkDisponivel">Só disponível</label>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end gap-1 mt-2">
          <button class="btn btn-sm btn-outline-secondary" @click="limpar">Limpar</button>
          <button class="btn btn-sm btn-primary" @click="aplicar">Aplicar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  aberta: { type: Boolean, default: false },
  filtros: { type: Object, default: () => ({}) }
})

const emit = defineEmits(['fechar', 'aplicar'])

const filtrosLocais = ref({
  numeroDocumentoEntrada: '',
  numeroDocumentoTransporte: '',
  dataEtaInicio: '',
  dataEtaFim: '',
  ocultarSaldoZero: false,
  apenasDisponivel: false
})

watch(() => props.aberta, (val) => {
  if (val) filtrosLocais.value = { ...props.filtros }
})

function aplicar () {
  emit('aplicar', { ...filtrosLocais.value })
}

function limpar () {
  filtrosLocais.value = {
    numeroDocumentoEntrada: '',
    numeroDocumentoTransporte: '',
    dataEtaInicio: '',
    dataEtaFim: '',
    ocultarSaldoZero: false,
    apenasDisponivel: false
  }
  aplicar()
}
</script>

<style scoped>
.gaveta-filtros {
  --gaveta-bg: var(--bs-body-bg);
  --gaveta-border: var(--bs-border-color);
  position: fixed;
  top: 56px;
  left: 0;
  right: 0;
  z-index: 1040;
  transform: translateY(-100%);
  transition: transform 0.25s ease;
  background: var(--gaveta-bg);
  border-color: var(--gaveta-border) !important;
}

.gaveta-aberta {
  transform: translateY(0);
}

.gaveta-titulo {
  color: var(--bs-body-color);
}

.gaveta-label {
  color: var(--bs-secondary-color);
}
</style>
